import { FunctionComponent } from 'react'
import { ContentLayout, ContentLayoutProps } from '@conexasaude/hero-web'
import ProtectedSiteStamp from '../ProtectedSiteStamp'

const CustomLayout: FunctionComponent<ContentLayoutProps> = ({
  children,
  ...props
}) => {
  const headerSize = 72
  const menuSize = 56
  const floatingFooterSize = 80
  const contentPaddingTopSize = 16
  const descreaseTotal =
    headerSize + menuSize + floatingFooterSize + contentPaddingTopSize

  const hasFooter =
    props.hasPrimaryAction ||
    props.hasSecondaryAction ||
    props.hasNegativeAction

  return (
    <ContentLayout
      fullHeight={false}
      customFooter={<ProtectedSiteStamp />}
      styles={{
        root: {
          minHeight: `calc(100vh - ${hasFooter ? descreaseTotal : '16'}px)`,
        },
      }}
      {...props}
    >
      {children}
    </ContentLayout>
  )
}

export default CustomLayout
